import 'axios';
import axios from './axiosInstance2.js';
import { BAD_REQUEST } from './responses2.js';

/**
 * Fetches data from the supplied API endpoint.
 *
 * HTTP status code 200 returns plain text (data found).
 * HTTP status code 400 throws an Error (bad request).
 *
 * @internal
 * @private
 * @param {string} endpoint the API endpoint to query
 * @param {object} [options] a configuration object
 * @param {string} [options.baseUrl] a custom base URL for the
 * pwnedpasswords.com API endpoints (default: `https://api.pwnedpasswords.com`)
 * @param {string} [options.userAgent] a custom string to send as the User-Agent
 * field in the request headers (default: `hibp <version>`)
 * @returns {Promise<string>} a Promise which resolves to the data resulting
 * from the query, or rejects with an Error
 */
var fetchFromApi = (function (endpoint) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var baseUrl = options.baseUrl, userAgent = options.userAgent;
    var config = Object.assign({}, baseUrl ? {
        baseURL: baseUrl
    } : {}, userAgent ? {
        headers: {
            'User-Agent': userAgent
        }
    } : {});
    return Promise.resolve(axios.get(endpoint, config)).then(function (res) {
        return res.data;
    }).catch(function (err) {
        if (err.response) {
            switch (err.response.status) {
                case BAD_REQUEST.status:
                    throw new Error(err.response.data);
                default:
                    throw new Error(err.response.statusText);
            }
        }
        else {
            throw err;
        }
    });
});

export default fetchFromApi;
//# sourceMappingURL=fetchFromApi2.js.map



//////////////////
// WEBPACK FOOTER
// ./~/hibp/es/fetchFromApi2.js
// module id = ./node_modules/hibp/es/fetchFromApi2.js
// module chunks = 2